export const getPaymentAmount = ({
  balance,
  depositDue,
  totalPayments,
}: {
  balance: number;
  depositDue?: number;
  totalPayments?: number;
}) => {
  if (depositDue && (totalPayments || totalPayments === 0)) {
    if (depositDue > totalPayments) {
      return depositDue - totalPayments;
    }
  }
  return balance;
};
